import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import Badge from "@mui/material/Badge";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { cartsItems } from "../../apis/cartsApiSlice";

const Header = () => {
  const carts = useSelector(cartsItems);

  const pagesList = ["All Products", "Clothing", "Jewelery", "Electronics"];

  const navigate = useNavigate();

  const [cartItems, setCartItems] = useState(0);
  const [state, setState] = useState({
    left: false,
  });

  useEffect(() => {
    setCartItems(carts?.length ?? 0);
  }, [carts]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const navigateLinks = (e, data) => {
    e.preventDefault();
    const page = data.toLowerCase();

    if (page.slice(" ").length > 1) {
      navigate(`/${page.replace(" ", "_")}`);
    } else {
      navigate(`/${data.toLowerCase()}`);
    }
  };

  return (
    <>
      <header className="w-full fixed top-0 left-0 z-[1001] bg-white shadow-md">
        <div className="container flex justify-between items-center py-4 px-4 sm:px-8 mx-auto">
          <button
            className="sm:hidden ml-0 mr-4 text-primary"
            onClick={toggleDrawer("left", true)}
          >
            <MenuIcon />
          </button>
          <div className="absolute sm:hidden w-[100px] top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
            <Link to="/">
              <img src="./img/logo.png" alt="logo" />
            </Link>
          </div>
          <div className="hidden sm:block w-[100px]">
            <Link to="/">
              <img src="./img/logo.png" alt="logo" />
            </Link>
          </div>
          <nav className="hidden sm:block absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
            <ul className="flex">
              {pagesList.length &&
                pagesList.map((page, index) => (
                  <li
                    className="hover:bg-secondary py-4 px-6 cursor-pointer"
                    onClick={(e) => navigateLinks(e, page)}
                    key={index}
                  >
                    {page}
                  </li>
                ))}
            </ul>
          </nav>
          <Badge
            className="cursor-pointer"
            badgeContent={cartItems}
            color="error"
            onClick={(e) => navigateLinks(e, "cart")}
          >
            <ShoppingCartIcon />
          </Badge>
        </div>
      </header>
      <Drawer
        className="w-62"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
      >
        <div
          className="w-60 h-screen p-6"
          role="presentation"
          onClick={toggleDrawer("left", false)}
          onKeyDown={toggleDrawer("left", false)}
        >
          <nav className="">
            <ul className="flex flex-col">
              {pagesList.length &&
                pagesList.map((page, index) => (
                  <li
                    className="pt-4 cursor-pointer"
                    onClick={(e) => navigateLinks(e, page)}
                    key={index}
                  >
                    {page}
                  </li>
                ))}
            </ul>
          </nav>
        </div>
      </Drawer>
    </>
  );
};

export default Header;
